import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private initialized = false;

  constructor(private config: ConfigService) { }

  initGA() {
    if (this.initialized) return;
    const id = this.config.measurementId; // getter ที่คุณสร้างใน ConfigService
    if (id && !window['gtag']) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      script.async = true;
      document.head.appendChild(script);

      window['dataLayer'] = window['dataLayer'] || [];
      function gtag(){window['dataLayer'].push(arguments);}
      window['gtag'] = gtag;
      window['gtag']('js', new Date());
      window['gtag']('config', id);

      this.initialized = true;
    }
  }
}
